<template>
  <div class="font-size-zero">
    <a
      @click="$emit('click')"
      v-if="data"
      v-tooltip="tooltip"
      class="avatar avatar-name avatar-xs avatar-assigned-by  text-white rounded-circle"
      :class="userAvatar(data && data.user).bg"
      data-target="offcanvasFrom"
      data-offcanvasfrom="offcanvas"
      data-role-id="1"
      data-role-name="OWNER"
      href="javascript:void(0)"
    >
      <span  v-if="!userAvatar(data && data.user).hasImage">{{
        userAvatar(data && data.user).avatar
      }}</span>
      <img
        v-if="userAvatar(data && data.user).hasImage"
        alt="Image placeholder"
        :src="userAvatar(data && data.user).avatar"
      />
    </a>
    <a
      v-if="!data && disableEdit != true"
      @click="$emit('click')"
      href="javascript:void(0)"
      class="to-3 avatar avatar--38 rounded-circle"
      v-tooltip.top-center="title || `Add new user`"
      data-target="offcanvascced_int"
      data-offcanvasfrom="offcanvas"
    >
      <i class="fas fa-plus text-xs"></i>
    </a>

    <a
      v-if="!data && disableEdit == true"
      @click="$emit('click')"
      href="javascript:void(0)"
      class="to-3 avatar avatar--38 rounded-circle"
      v-tooltip.top-center="title || `No User Assigned`"
      data-target="offcanvascced_int"
      data-offcanvasfrom="offcanvas"
    >
      <i class="fas fa-user text-md"></i>
    </a>

    
  </div>
</template>

<script>
export default {
  props: ["data", "title", "click", "disableEdit"],
  name: "UserAvatar",
  
  computed: {
    tooltip() {
      if (this.title) {
        return this.title;
      }
      if(this.data && this.data.user) {
        return this.data.user.first_name + " " + this.data.user.last_name;
      }
      
    }
  },
  methods: {
    userAvatar(user) {
      let avatar = "";
      let bg_colors = [
        "bg-success",
        "bg-info",
        "bg-default",
        "bg-darker",
        "bg-danger"
      ];
      let bg = "bg-success";
      let hasImage = false;
      if (user) {
        if (user.profile_pic != null) {
          avatar = user.profile_pic.file_url;
          hasImage = true;
        } else {
          hasImage = false;
          let ch =
            user.first_name && user.first_name.substring(0, 1).toUpperCase();
          bg = bg_colors[(ch.charCodeAt(0) + user.first_name.length) % 5];
          avatar =
            user.first_name &&
            user.first_name.substring(0, 1).toUpperCase() +
              (
                (user.last_name && user.last_name.substring(0, 1)) ||
                ""
              ).toUpperCase();
        }
      } else {
        avatar = "NU";
        //task_return += '<span class="mr-1"><i class="fas fa-arrow-'+task.which_task+'"></i></span>';
      }

      // <span data-toggle="tooltip" data-trigger="hover" title="No User" class="d-flex mr-1"><a href="#" class="avatar avatar-name avatar-sm  '+bg+' text-xl text-white rounded-circle" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas">NU</a></span>

      return {
        hasImage: hasImage,
        avatar: avatar,
        bg: bg
      };
    }
  }
};
</script>

<style></style>
